import axios from "axios";
import { getToken } from "./utilsApi";

/**
 * Two-step sign-in (MFA) and district idle sign-out (Nov 2026, multi-tenant security).
 *  - mfa(): POST {auth}/auth/mfa {action, ...}. Sends the signed-in token when there is one;
 *    mid-sign-in calls carry a setupId (setup) or session (code) instead.
 *  - security settings: GET/POST {portal}/security-settings
 */
const mfaUrl = () => `${process.env.REACT_APP_baseAuthUrl}auth/mfa/`;
const settingsUrl = () => `${process.env.REACT_APP_apiBaseUrl}security-settings`;

const result = (res) => ({ ok: true, status: res.status, data: res.data });
const failure = (error, fallback) => ({
  ok: false,
  status: error?.response?.status || 500,
  message: error?.response?.data?.message || error?.response?.data?.error || fallback,
});

export const mfa = async (payload, { signedIn = false } = {}) => {
  const headers = { "Content-Type": "application/json" };
  if (signedIn) headers["x-api-key"] = await getToken();
  try {
    return result(await axios({ method: "POST", url: mfaUrl(), headers, data: payload }));
  } catch (error) {
    return failure(error, "Something went wrong. Please try again.");
  }
};

export const getSecuritySettings = async (district) => {
  try {
    const res = await axios({
      method: "GET", url: settingsUrl(), headers: { "x-api-key": await getToken() },
      params: district ? { district } : {},
    });
    return { ok: true, ...res.data };
  } catch (error) {
    return failure(error, "Couldn't load the security settings.");
  }
};

export const saveSecuritySettings = async (district, values) => {
  try {
    const res = await axios({
      method: "POST", url: settingsUrl(),
      headers: { "x-api-key": await getToken(), "Content-Type": "application/json" },
      data: { district, ...values },
    });
    return { ok: true, ...res.data };
  } catch (error) {
    return failure(error, "Couldn't save the security settings.");
  }
};

/** Where to go after the server answers a sign-in step. Returns true when it navigated. */
export const routeSignInStep = (data, navigate) => {
  if (data?.challengeName === "MFA") {
    navigate("/auth/mfa", { state: { mode: "code", ...data } });
    return true;
  }
  if (data?.challengeName === "MFA_SETUP") {
    navigate("/auth/mfa", { state: { mode: "setup", ...data } });
    return true;
  }
  return false;
};
